import * as React from 'react';
import { Task } from './Tasks';

interface TaskAssignHiddenButtonProps {
  index: number;
  task: Task;
  onEnterTaskNameAssigning(index: number): void;
}

export default class TaskAssignHiddenButton extends React.Component<TaskAssignHiddenButtonProps> {
  render() {
    const { task } = this.props;
    return (
      <a
        onMouseDown={this.onMouseDown}
      >
        {assignedToJsx(task.assignedTo)}
      </a>
    )
  }

  onMouseDown = () => {
    const { index, onEnterTaskNameAssigning } = this.props;
    onEnterTaskNameAssigning(index);
  }
}


function assignedToJsx(names: string[]) {
  if (!names || names.length === 0) {
    return (<span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>);
  } else {
    return <i>({names.join(', ')})</i>
  }
}



// WEBPACK FOOTER //
// ./src/tasks/TaskAssignHiddenButton.tsx